/**
 * Persist collapse state in Redux (ui.collapsedTables) keyed by `{fileId}::{provenanceUuid}` to
 * avoid collisions across documents (e.g. grids created from templates sharing the same provenanceUuid).
 * This ensures the state survives virtualization unmount/remount cycles.
 * @param fileId File ID
 * @param provenanceUuid Unique identifier for note linked group.
 */
export function generateNoteLinkedObjectCollapseId(fileId: string, provenanceUuid: string): string {
  return `${fileId}::${provenanceUuid}`;
}
